/**
 * External dependencies
 */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';

/**
 * Internal dependencies
 */
import { requestConnections } from 'state/connections/actions';
import { isRequestingConnections } from 'state/connections/selectors';

const QueryConnections = (props) => {
    useEffect(() => {
        props.requestConnections();
    }, []);
    return null;
};

export default connect(
    (state) => ({
        requestingWidgets: isRequestingConnections(state),
    }),
    {
        requestConnections,
    },
)(QueryConnections);